import { render, staticRenderFns } from "./Melaleggo.vue?vue&type=template&id=372e7c3a"
import script from "./Melaleggo.vue?vue&type=script&lang=js"
export * from "./Melaleggo.vue?vue&type=script&lang=js"
import style0 from "./Melaleggo.vue?vue&type=style&index=0&id=372e7c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports